import { gql } from "@/gql/__generated__";
import { useQuery } from "@apollo/client";

export const OUTBOUND_SUBSCRIPTIONS = gql(`
    query OutboundSubscriptions($organizationSlug: String!) {
        organization(organizationSlug: $organizationSlug ) {
            ... on Organization {
                __typename
                id
                outboundSubscriptions { ... AppSubscriptions }
            }
        }
    }
`);

type Props = { organizationSlug?: string };

export const useOutboundSubscriptions = ({ organizationSlug = "" }: Props) => {
  const { data, ...rest } = useQuery(OUTBOUND_SUBSCRIPTIONS, {
    variables: { organizationSlug },
    skip: organizationSlug === ""
  });

  const subscriptions =
    data?.organization.__typename === "Organization"
      ? data.organization.outboundSubscriptions
      : [];

  return { ...rest, data: subscriptions };
};
